import React from "react";

/**
 * Componente para barra de filtros e ações
 */
const FilterBar = ({
  statusOptions,
  selectedStatus,
  selectedItemsCount,
  onStatusChange,
  onBatchDelete,
  nameFilter,
  onNameFilterChange,
}) => {
  const inputCls = "px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring bg-white";

  return (
    <div className="bg-white rounded-xl border border-border p-4 mb-4 flex flex-wrap gap-4 items-end">
      <div className="flex flex-col gap-1 flex-1 min-w-[160px]">
        <label htmlFor="name-filter" className="text-xs font-medium text-muted-foreground">Nome</label>
        <input
          id="name-filter" type="text" value={nameFilter} onChange={onNameFilterChange}
          className={inputCls} placeholder="Filtrar por nome..."
        />
      </div>

      <div className="flex flex-col gap-1">
        <label htmlFor="status-filter" className="text-xs font-medium text-muted-foreground">Status</label>
        <select id="status-filter" value={selectedStatus} onChange={onStatusChange} className={inputCls}>
          {statusOptions.map((option) => (
            <option key={option.key} value={option.value}>{option.value}</option>
          ))}
        </select>
      </div>

      <button
        className="px-4 py-2 text-sm font-medium rounded-md bg-red-500 hover:bg-red-600 text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed self-end"
        onClick={onBatchDelete}
        disabled={selectedItemsCount === 0}
      >
        Excluir Selecionados ({selectedItemsCount})
      </button>
    </div>
  );
};

export default FilterBar;
